import React, { useEffect } from 'react'
import LoadingSpinner from 'cwp-components/base/LoadingSpinner'
import { ProfileBioSection } from './ProfileBioSection'
import { ProfileHeader } from './ProfileHeader/ProfileHeader'
import { ProfileInformation } from './ProfileInformation/ProfileInformation'
import { MemberProfileExtendedType } from 'common/types/MemberProfile'
import { getMembershipExtendedColors } from 'cwp-components/CWP Sections/MemberProfile/common/membershipStyles'
import { ProfileReviews } from 'cwp-components/CWP Sections/MemberProfile/Extended/ProfileReviews'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'
import { ProfileReview } from 'cwp-components/CWP Sections/MemberProfile/Extended/ProfileReview'
import SeeMore from 'cwp-components/SeeMore'
import { ProfileTeam } from './ProfileTeam/ProfileTeam'
import ProfileArticle from './ProfileArticle/ProfileArticle'
import { useReviews } from 'common/hooks/useReviews'

interface MemberProfileExtendedProps {
  profile: MemberProfileExtendedType
  reloadProfile: () => void
}

export function MemberProfileExtended({
  profile,
  reloadProfile,
}: MemberProfileExtendedProps) {
  const colors = getMembershipExtendedColors(profile?.metadata.membership_type)

  // TODO: Implement loading state and error handling and error component if no data is returned
  // This is a quick hack as we have no design for loading state
  if (!profile)
    return (
      <>
        <div className='mt-[105px] md:my-4 h-full bg-white sm:mx-10 min-w-[372px]  sm:shadow-[0px_4px_60px_0px_rgba(0,0,0,0.08)]  md:shadow-[0px_0px_30px_0px_rgba(0,0,0,0.10)] rounded-t-[12px] md:rounded-[60px] text-center pt-10'>
          <h1 className='text-[#405985] text-lg font-bold mb-8'>
            Loading profile...
          </h1>
          <LoadingSpinner />
        </div>
      </>
    )
  const { results: articles, loadArticles } = useArticleTemplate()
  const { reviews, getReviews, loadMore, isLoadMore } = useReviews({
    type: profile.memberEntity,
    id: profile.metadata.id,
  })
  useEffect(() => {
    loadArticles()
  }, [])
  useEffect(getReviews, [getReviews])
  const filterdArticles = articles.filter((article) => {
    return article?.tags?.some((tag) =>
      profile.professional_core.areas_of_law.includes(tag),
    )
  })

  return (
    <>
      <div className='relative flex justify-center mt-4 h-20 lg:h-28 lg:hidden lg:-mt-28'>
        <div className='absolute z-10'>
          <ProfileInformation profile={profile} />
        </div>
      </div>
      <div className='bg-white sm:mx-10 mt-2 lg:mt-4 mb-2 lg:mb-4 min-w-[372px] shadow-[0px_0px_30px_0px_rgba(0,0,0,0.10)] rounded-2xl md:rounded-[60px]'>
        <ProfileHeader profile={profile} reloadProfile={reloadProfile} />
        <div>
          <div
            className={`absolute ${colors.cardBg} h-[429px] left-0 right-0 sm:left-10 sm:right-10`}
          ></div>
          <div className='relative pt-8 pb-8 pl-[35px] md:pl-[93px] md:pr-12 xl:pr-12'>
            <div className='flex gap:10 lg:gap-[64px]'>
              {/* this div is where the strong left vertial line is */}
              <div
                className={`border-l-4 md:border-l-[5px] ${colors.bioLeftBorder} border-solid pl-5`}
              >
                <ProfileBioSection profile={profile} />
                {reviews?.length > 0 && (
                  <ProfileReviews reviewsSummary={profile['reviews_summary']} />
                )}
                <div className='w-full mt-4'>
                  {reviews?.length
                    ? reviews.map((item) => <ProfileReview reviewData={item} />)
                    : 'No Reviews'}
                </div>
                {isLoadMore && (
                  <div className='w-full flex justify-end pr-4'>
                    <SeeMore onClick={loadMore} />
                  </div>
                )}
              </div>

              {/* hidden lg:flex DOES NOT WORK so we use max-lg:hidden instead (ie the opposite way round!)
              see https://stackoverflow.com/questions/68981642/display-hidden-not-working-with-flex-in-tailwind */}
              <div className='flex max-lg:hidden lg:-mt-11'>
                <div className='flex max-lg:hidden lg:-mt-11'>
                  <ProfileInformation profile={profile} />
                </div>
              </div>
            </div>
            <div className='flex flex-wrap mt-4 md:flex-row gap-[15px] lg:gap-[24px]  items-center pt-3'>
              {filterdArticles.map((article) => (
                <ProfileArticle article={article} />
              ))}
            </div>
            {filterdArticles.length > 0 && (
              <div className='w-full flex justify-end'>
                <SeeMore />
              </div>
            )}
          </div>
        </div>
        <ProfileTeam profile={profile} />
      </div>
    </>
  )
}
